import { formatDate } from '@/util/helpers'

export default function () {
  return {
    testimonials: [],
    showDeleteDialog: false,
    deletingId: null,
    orderChanged: false,
    formatDate,
  }
}
